import { DeviceTypeEnum } from 'Types/deviceTypes'

export const RENTALS_DEVICE_CATEGORY_OTHER_VALUE = '__RENTALS_DEVICE_CATEGORY_OTHER__'

export const RENTALS_DEVICE_CATEGORY_CORE_VALUES = [
  DeviceTypeEnum.smartphone,
  DeviceTypeEnum.tablet,
  DeviceTypeEnum.laptop,
] as const

export const CORE_SET = new Set<string>(RENTALS_DEVICE_CATEGORY_CORE_VALUES)
